import {Pipe, PipeTransform} from '@angular/core';
import {Benutzer} from '../../../clients/veranstaltungen';
import {forEach} from '@angular-devkit/schematics';

@Pipe({
    name: 'displaybenutzerliste',
    pure: false
})
export class DisplayBenutzerListePipe implements PipeTransform {
    constructor() {
    }

    static getDisplayBenutzerText(benutzerId: string, benutzer: Benutzer, format?: number) {
        if (benutzerId !== null && benutzer === null) {
            return 'Benutzer ausgeschieden?';
        } else if (benutzer !== null) {
            if (format === 1) {
                return benutzer.display_vorname_nachname;
            } else if (format === 2) {
                return benutzer.display_nachname_vorname;
            } else {
                // Standard
                return benutzer.display_vorname_nachname;
            }
        } else {
            return '';
        }
    }

    transform(benutzerliste: Array<Benutzer>, format?: number) {

        let s = '';

        if (!benutzerliste)
            return '';

        if (benutzerliste === null)
            return '';

        benutzerliste.forEach(b => {
            if (s.length > 0) {
                s = s + ', ';
            }
            s = s + DisplayBenutzerListePipe.getDisplayBenutzerText(b.benutzer_id, b, format);
        });

        return s;
    }
}
